import {DashboardWFRecord, Detail} from "@commons/mapping/dashboard.types";
import {MonitorWFParams} from "@commons/services/presenze_api/dashboard.api";
import React from "react";
import classNames from "classnames";
import styles from "../wf.dashboard.module.css";
import {CellDetail, DaEvadereIcon, InAttesaIcon, InValutazioneIcon, Triangle} from "./wf.dashboard.comps";
import TooltipEx from "../../../../components/Tooltip";

export type DayParams = Pick<DashboardWFRecord, 'idAziendaMaster' | 'idAzienda' | 'id' | 'details'>;

interface DayProps {
    className?: string,

    details: Detail[], //array con i dettagli per la giornata indicata da giorno

    idAziendaMaster: number,
    idAzienda: number,
    idDip: number,
    isSelected: boolean,
    onClick: (params: DayParams) => void,
    monitorWFParams: MonitorWFParams,
}

export const DayCell: React.FC<DayProps> = ({className, details, onClick, idAziendaMaster, idAzienda, idDip, monitorWFParams, isSelected}) => {

    const onCellClick = () => {
        if (onClick) onClick({idAziendaMaster: idAziendaMaster!, idAzienda: idAzienda!, id: idDip!, details: details!});
    }

    let border: string;
    if (monitorWFParams && monitorWFParams.idDip === idDip) {
        if (isSelected) {
            border = 'border-l-2 border-l-gray-500 border-t-2 border-t-gray-500 border-r-2 border-r-gray-500';
        } else {
            border = 'pb-1 border-b-2 border-b-gray-500';
        }
    } else border = '';

    const commonClassNames = classNames(styles.cella,
        (border && isSelected) ? styles.cella_sel_w : styles.cella_w,
        !(border && isSelected) && 'border-r',
        className);

    if (details && details.length > 0) {
        const presenteBgColor = details[0].hhWeekMedie === 40 ? styles.presenteFT : styles.presentePT;
        const previsto = details[0].hhPreviste / 60.0;
        let assenze = 0;
        let giornataIntera = false;
        let richiesteInAttesa = false;
        let richiesteInValutazione = false;
        let numRichieste = 0; // details.length
        let bgColorCausale: { backgroundColor: string } | null = null;
        for (let detail of details) {
            numRichieste += detail.wf ? 1 : 0;
            if (detail.wf && !detail.wf.annullata && detail.wf.stato !== 'RIFIUTATA') {

                if (detail.tipoCausale === 'ORE_MANCANTI' || detail.tipoCausale === 'MANUTENZIONE_TIMBRATURE') {
                    if (detail.tipoCausale === 'ORE_MANCANTI') {
                        if (detail.giornataIntera) giornataIntera = true;
                        else
                            assenze += detail.quantita || 0;
                    } else { // MANUTENZIONE_TIMBRATURE
                        giornataIntera = true;
                    }

                    // Determino colore primo piano assenza
                    if (detail.coloreCausale) {
                        if (bgColorCausale === null || bgColorCausale.backgroundColor === detail.coloreCausale) // se nullo o come precedente
                            bgColorCausale = {backgroundColor: detail.coloreCausale};
                        else
                            bgColorCausale = {backgroundColor: 'currentColor'}; // altrimenti fisso il colore di default!
                    }
                }

                if (detail.wf.stato === 'IN_ATTESA')
                    richiesteInAttesa = true;

                if (detail.wf.stato === 'IN_VALUTAZIONE')
                    richiesteInValutazione = true;
            }

            if (detail.tipoOreGiustificativo === 'M')
                assenze += detail.quantitaGiustificativo || 0;
        }

        /*
                // Aggiungo eventuali ore mancanti dai giustificativi. N.B. le informazioni dai giustificativi presenze sono replicate e identiche su ciascun elemento dell'array, prendo quindi il primo...
                if (details[0].tipoOreGiustificativo === 'M')
                    assenze += details[0].quantitaGiustificativo || 0;
        */
        if (giornataIntera)
            assenze = previsto;

        // Colore di background standard (fissato con la classe), il colore custon verrà invece impostato attraverso l'attributo <style>
        const bgColor = previsto > 0 ? (assenze >= previsto ? styles.assenteBgColor : presenteBgColor) : styles.senzaPrevisto;
        let cell: React.ReactNode;
        if (previsto > 0 && assenze > 0)
            cell = (<div className={classNames(commonClassNames, bgColor, styles.assenteColor, 'relative')} style={assenze >= previsto && bgColorCausale ? bgColorCausale : undefined}
                         onClick={() => onCellClick()}>
                {assenze < previsto && <span><Triangle bgColor={bgColorCausale?.backgroundColor}/></span>}
                {numRichieste > 1 && <span className={styles.numeroRichiesteWF}>
                        {numRichieste < 10 ? numRichieste : '+'}
                </span>}
                {richiesteInAttesa && !richiesteInValutazione && <InAttesaIcon withNumber={numRichieste > 1}/>}
                {richiesteInValutazione && !richiesteInAttesa && <InValutazioneIcon withNumber={numRichieste > 1}/>}
                {richiesteInValutazione && richiesteInAttesa && <DaEvadereIcon withNumber={numRichieste > 1}/>}
            </div>);
        else
            cell = <div className={classNames(commonClassNames, bgColor)} onClick={() => onCellClick()}>&nbsp;</div>;

        return <div className={border}><TooltipEx tooltip={<CellDetail details={details}/>} placement="bottom">{cell}</TooltipEx></div>
    } else
        return <div className={border}>
            <div className={classNames(commonClassNames)}></div>
        </div>
}
